import { Component, OnInit } from '@angular/core';
import { CommonComponent } from '@components/abstract/common-component.component';
import { DropZoneInputComponent } from '@ui/abstract/drop-zone-input.component';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-drop-zone-input-style-one',
  templateUrl: './drop-zone-input-style-one.component.html',
  styleUrls: ['./drop-zone-input-style-one.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: DropZoneInputStyleOneComponent,
      multi: true,
    },
  ],
})
export class DropZoneInputStyleOneComponent extends DropZoneInputComponent {}
